import React from 'react';
import BaseScoreForm from './BaseScoreForm';
import { ScoreDTO, CourseDTO } from '../../services/apiClient';
import { ScoreTypeConstants } from '../../constants/ScoreTypeConstants';
import { filterExerciseTypesByCourseFirearmAndCaliber } from '../../utils/filterExerciseTypes';

interface EvaluationScoreFormProps {
  initialValues: ScoreDTO;
  course: CourseDTO;
  onSubmit: (data: ScoreDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const EvaluationScoreForm: React.FC<EvaluationScoreFormProps> = ({
  course,
  ...props
}) => {
  return (
    <BaseScoreForm
      {...props}
      course={course}
      exerciseTypeFilter={filterExerciseTypesByCourseFirearmAndCaliber}
      scoreTypeConstant={ScoreTypeConstants.COURSE_PRACTICAL_EVALUATION}
      eventTypeMessage={`Event Type: ${props.initialValues.scoreType?.title || 'Course Practical Evaluation'}`}
    />
  );
};

export default EvaluationScoreForm;
